import 'twin.macro';
import { RectangleStackIcon as Collection } from '@heroicons/react/24/outline';
import React from 'react';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';
import { tagBackgroundColors, tagTextColor } from 'styles/userConstants';
import { css } from 'twin.macro';

export function SequenceIcon(props: IconProps) {
  return (
    <Collection
      tw="p-1 rounded-lg"
      css={[
        css`
          background-color: ${tagBackgroundColors['cassis-quiet']};
          color: ${tagTextColor.cassis};
        `,
      ]}
      className={props.className}
      {...props}
    />
  );
}
